import { useParams } from 'react-router-dom';
import { decryptURL } from 'utils/functions';
import MercadoLivre from './MercadoLivre';

const Detalhes = () => {
  const { hash } = useParams();
  const decrypt = decryptURL(hash);

  const props = {};

  switch (decrypt?.marketplace) {
    case 'MERCADO LIVRE':
      return <MercadoLivre {...props} />;
    default:
      return null;
  }
};

export default Detalhes;
